import { createActionType } from 'app/store/utils';

const type = createActionType('exploreData');

export const SET_DATASET_COLUMN_FILTER = type('SetDatasetColumnFilter');
export const SET_EXPLORE_COLUMN_FILTER = type('SetExploreColumnFilter');
